// Thin wrapper around Meta Pixel's `fbq`. Safe if the pixel hasn't loaded yet.
export const fbq = (...args) => {
  if (typeof window === "undefined") return;
  if (typeof window.fbq !== "function") return;
  try { window.fbq(...args); } catch (e) { /* noop */ }
};

export const track = (event, params) => fbq("track", event, params);
export const trackPageView = () => fbq("track", "PageView");
